import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-button.js';
import '@adornis/chemistry/elements/components/x-grid.js';
import '@adornis/chemistry/elements/components/x-link.js';
import { makeRouter } from '@adornis/router/client/make-router.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { currentUser, impersonatingUser } from '@adornis/users/client/currentUser.js';
import { embedPages } from '@ils/static/enums.js';
import { watch } from '@lit-labs/preact-signals';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { state } from 'lit/decorators/state.js';
import type { ILSUser } from '../../db/ils-user.js';
import '../components/ils-exam-days-embed.js';
import '../components/ils-product-card.js';
import './ils-product-page.js';

export const embedRouter = makeRouter(
  {
    root: {
      path: '/',
      render: () => html` <x-text> embed root </x-text> `,
    },
    signup: {
      path: `/${embedPages.SIGNUP}/:examType?`,
      render: params =>
        html`
          <x-flex space="md" padding="md">
            <x-flex horizontal space="md">
              <x-button
                mode=${params.examType !== 'FSPP' ? 'action' : 'outline'}
                @click=${() => goTo(`/embed/${embedPages.SIGNUP}/FAMED`)}
              >
                FAMED
              </x-button>
              <x-button
                mode=${params.examType === 'FSPP' ? 'action' : 'outline'}
                @click=${() => goTo(`/embed/${embedPages.SIGNUP}/FSPP`)}
              >
                FSPP
              </x-button>
            </x-flex>
            <ils-product-page exam-type=${params.examType} ${css({ border: `1px dashed #ccc` })}></ils-product-page>
          </x-flex>
        `,
    },
    examdays: {
      path: `/${embedPages.EXAMDAYS}/:examType?`,
      render: params =>
        html`
          <x-flex space="md" padding="md">
            <x-flex horizontal space="md">
              <x-button
                mode=${params.examType !== 'FSPP' ? 'action' : 'outline'}
                @click=${() => goTo(`/embed/${embedPages.EXAMDAYS}/FAMED`)}
              >
                FAMED
              </x-button>
              <x-button
                mode=${params.examType === 'FSPP' ? 'action' : 'outline'}
                @click=${() => goTo(`/embed/${embedPages.EXAMDAYS}/FSPP`)}
              >
                FSPP
              </x-button>
            </x-flex>
            <ils-exam-days-embed
              exam-type=${params.examType}
              ${css({ border: `1px dashed #ccc` })}
            ></ils-exam-days-embed>
          </x-flex>
        `,
    },
  },
  {
    fallback: () => html` <x-flex padding="lg"> <x-h1> 403 </x-h1> </x-flex> `,
  },
);

@customElement('ils-embed')
export class ILSEmbedPage extends ChemistryLitElement {
  override styles() {
    return [{ ':host': { height: '100%', width: '100%' } }];
  }

  @state() public user = new RXController(this, currentUser<ILSUser>());
  @state() public impersonating = new RXController(this, impersonatingUser<ILSUser>());

  override render() {
    return html`
      <x-flex horizontal ${css({ height: '100%', width: '100%' })}>
        <x-flex flex ${css({ minWidth: '0' })}> ${watch(embedRouter.outlet)} </x-flex>
      </x-flex>
    `;
  }
}
